/**
 * Wristband Fee System
 * Adds wristband fees on ADD TO CART click based on location and date rules
 */

(function() {
  const WRISTBAND_PRODUCTS = {
    'Gruene': 'nb-city-wristband',
    'The Double': 'nb-city-wristband',
    'Comal': 'nb-city-wristband',
    'Riverbank': 'word-wristband',
    'Huaco': 'word-wristband',
    'TEST': 'test-wristband-fee'
  };
  
  const NB_CITY_LOCATIONS = ['Gruene', 'The Double', 'Comal'];
  const WORD_LOCATIONS = ['Riverbank', 'Huaco'];
  const DEBUG = false;
  
  let isAddingFee = false;
  
  function log(message) {
    if (DEBUG) console.log('[Wristband Fee]:', message);
  }

  function dispatchWristbandEvent(name, detail = {}) {
    try {
      document.dispatchEvent(new CustomEvent(`rockinr:wristband-fee:${name}`, { detail }));
    } catch (e) {
      log(`Error dispatching event '${name}': ${e.message}`);
    }
  }
  
  function isTestCollection() {
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('/collections/test')) return true;
    
    const productMeta = document.querySelector('meta[property="og:product:collection"], meta[name="collection"]');
    if (productMeta && productMeta.content && productMeta.content.toLowerCase().includes('test')) return true;
    
    return false;
  }
  
  function getBookingLocation() {
    try {
      const data = JSON.parse(localStorage.getItem('rockinRBookingData') || '{}');
      if (data.location) return data.location;
      if (isTestCollection()) return 'TEST';
      return null;
    } catch (e) {
      log('Error reading booking data: ' + e.message);
      return null;
    }
  }
  
  function getBookingDate() {
    try {
      const data = JSON.parse(localStorage.getItem('rockinRBookingData') || '{}');
      return data.date || null;
    } catch (e) {
      log('Error reading booking date: ' + e.message);
      return null;
    }
  }
  
  function getMemorialDay(year) {
    const may31 = new Date(year, 4, 31);
    const dayOfWeek = may31.getDay();
    const daysToSubtract = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    return new Date(year, 4, 31 - daysToSubtract);
  }
  
  function getLaborDay(year) {
    const sept1 = new Date(year, 8, 1);
    const dayOfWeek = sept1.getDay();
    const daysToAdd = dayOfWeek === 0 ? 1 : dayOfWeek === 1 ? 0 : 8 - dayOfWeek;
    return new Date(year, 8, 1 + daysToAdd);
  }
  
  function isSameDate(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }
  
  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }
  
  function isDateInRange(date, startDate, endDate) {
    return date >= startDate && date <= endDate;
  }
  
  function isNBCityWristbandRequired(dateString) {
    if (!dateString) return false;
    
    try {
      const [year, month, day] = dateString.split('-').map(Number);
      const bookingDate = new Date(year, month - 1, day);
      
      const memorialDay = getMemorialDay(year);
      const laborDay = getLaborDay(year);
      const july4th = new Date(year, 6, 4);
      
      if (isSameDate(bookingDate, memorialDay)) {
        log('Memorial Day - wristband required');
        return true;
      }
      
      if (isSameDate(bookingDate, july4th)) {
        log('July 4th - wristband required');
        return true;
      }
      
      if (isSameDate(bookingDate, laborDay)) {
        log('Labor Day - wristband required');
        return true;
      }
      
      const satBeforeMemorial = new Date(memorialDay);
      satBeforeMemorial.setDate(memorialDay.getDate() - 2);
      const sunBeforeMemorial = new Date(memorialDay);
      sunBeforeMemorial.setDate(memorialDay.getDate() - 1);
      
      if (isSameDate(bookingDate, satBeforeMemorial) || isSameDate(bookingDate, sunBeforeMemorial)) {
        log('Weekend before Memorial Day - wristband required');
        return true;
      }
      
      if (isWeekend(bookingDate) && isDateInRange(bookingDate, memorialDay, laborDay)) {
        log('Weekend during Memorial-Labor Day season - wristband required');
        return true;
      }
      
      log('Date does not require wristband');
      return false;
    } catch (e) {
      log('Error checking NB City wristband requirement: ' + e.message);
      return false;
    }
  }
  
  function shouldAddWristband(location) {
    if (!location) return false;
    
    if (location === 'TEST') {
      log('TEST location - wristband required');
      return true;
    }
    
    if (WORD_LOCATIONS.includes(location)) {
      log(`${location} is a WORD location - wristband always required`);
      return true;
    }
    
    if (NB_CITY_LOCATIONS.includes(location)) {
      const bookingDate = getBookingDate();
      if (!bookingDate) {
        log(`${location} is an NB City location but no booking date found - wristband not required`);
        return false;
      }
      const required = isNBCityWristbandRequired(bookingDate);
      log(`${location} is an NB City location, date: ${bookingDate}, wristband required: ${required}`);
      return required;
    }
    
    log(`${location} does not match any wristband requirement rules`);
    return false;
  }
  
  async function checkWristbandFeeInCart(location) {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return false;
      
      const cart = await response.json();
      const wristbandHandle = WRISTBAND_PRODUCTS[location];
      
      const hasWristbandFee = cart.items.some(item => 
        item.handle === wristbandHandle || 
        (item.properties && item.properties._wristband_fee_location === location)
      );
      
      log(`Wristband fee check for ${location}: ${hasWristbandFee ? 'FOUND' : 'NOT FOUND'}`);
      return hasWristbandFee;
    } catch (e) {
      log('Error checking cart: ' + e.message);
      return false;
    }
  }
  
  async function addWristbandFeeToCart(location, quantity = 1) {
    if (isAddingFee) {
      log('Already adding a wristband fee, skipping duplicate request');
      return;
    }
    
    isAddingFee = true;
    
    const handle = WRISTBAND_PRODUCTS[location];
    if (!handle) {
      log(`No wristband product defined for location: ${location}`);
      isAddingFee = false;
      return;
    }
    
    let additionSuccess = false;
    let additionAttempted = false;

    try {
      const feeAlreadyExists = await checkWristbandFeeInCart(location);
      if (feeAlreadyExists) {
        log(`Wristband fee for ${location} already exists, skipping addition`);
        isAddingFee = false;
        return;
      }

      dispatchWristbandEvent('add:start', { location, source: 'wristband-fee.js' });
      additionAttempted = true;
      
      const productResponse = await fetch(`/products/${handle}.js`);
      if (!productResponse.ok) {
        log(`Product not found: ${handle}. Please create it in Shopify.`);
        isAddingFee = false;
        return;
      }
      
      const product = await productResponse.json();
      if (!product.variants || !product.variants[0]) {
        log(`Invalid product data for: ${handle}`);
        isAddingFee = false;
        return;
      }
      
      const bookingDate = getBookingDate();
      
      const properties = {
        _wristband_fee_location: location,
        _wristband_fee: "true",
        "City-required item": `Wristband Fee for ${location}`,
        _timestamp: Date.now().toString()
      };
      
      if (bookingDate) {
        properties._wristband_fee_date = bookingDate;
        log(`Storing booking date with wristband: ${bookingDate}`);
      }
      
      if (location === 'TEST') {
        properties._test_collection = "true";
      }
      
      const formData = {
        items: [{
          id: product.variants[0].id,
          quantity: quantity,
          properties: properties
        }]
      };
      
      log(`Attempting to add wristband fee for ${location}...`);
      
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      
      if (addResponse.ok) {
        log(`Successfully added wristband fee for ${location} to cart`);
        additionSuccess = true;
        
        if (typeof window.refreshCart === 'function') {
          window.refreshCart();
        }
        
        document.dispatchEvent(new CustomEvent('cart:updated'));
      } else {
        const errorText = await addResponse.text();
        log(`Failed to add wristband fee to cart: ${addResponse.status} - ${errorText}`);
      }
    } catch (e) {
      log('Error adding wristband fee: ' + e.message);
    } finally {
      isAddingFee = false;
      if (additionAttempted) {
        dispatchWristbandEvent('add:complete', {
          location,
          success: additionSuccess,
          source: 'wristband-fee.js'
        });
      }
    }
  }
  
  function monitorAddToCartButtons() {
    log('Setting up ADD TO CART button monitoring');
    
    document.addEventListener('click', async function(event) {
      const addToCartHolder = event.target.closest('.add_to_cart_holder');
      if (!addToCartHolder) return;
      
      const isAddToCartButton = event.target.matches('button, input[type="submit"], .btn, [data-add-to-cart], .add-to-cart') ||
                               event.target.closest('button, input[type="submit"], .btn, [data-add-to-cart], .add-to-cart');
      
      if (!isAddToCartButton) return;
      
      log('ADD TO CART detected');
      log(`Clicked element: Tag: ${event.target.tagName}, Classes: ${event.target.className}`);
      
      const location = getBookingLocation();
      if (!location) {
        log('No location found for wristband fee');
        return;
      }
      
      log(`Location detected: ${location}`);
      
      if (!shouldAddWristband(location)) {
        log(`Wristband not required for ${location} on this date - skipping`);
        return;
      }
      
      log(`Wristband is required for ${location} - will add after product is added`);

      setTimeout(async () => {
        log(`Checking if wristband fee needs to be added for ${location}...`);

        const feeInCart = await checkWristbandFeeInCart(location);
        if (!feeInCart) {
          // Read quantity from cart after Shopify has processed the add
          let quantity = 1;
          try {
            const cartRes = await fetch('/cart.js');
            const cart = await cartRes.json();
            const wristbandHandles = Object.values(WRISTBAND_PRODUCTS);
            const tubeItems = cart.items.filter(item =>
              !wristbandHandles.includes(item.handle) &&
              !item.properties?._auto_tax &&
              !item.properties?._wristband_fee
            );
            if (tubeItems.length > 0) {
              quantity = tubeItems.reduce((sum, item) => sum + item.quantity, 0);
            }
          } catch (e) {
            log('Error reading cart for quantity: ' + e.message);
          }

          log(`Adding wristband fee for ${location} (qty: ${quantity})`);
          await addWristbandFeeToCart(location, quantity);
        } else {
          log(`Wristband fee for ${location} already in cart`);
        }
      }, 800);
      
    }, true);
  }

  function monitorCheckoutButtons() {
    log('Setting up checkout button monitoring');
    
    document.addEventListener('click', async function(event) {
      const isCheckoutButton = event.target.matches('[href*="/checkout"], [href*="/cart"], .checkout-btn, .cart-btn, [data-checkout], [name="add"]') ||
                              event.target.closest('[href*="/checkout"], [href*="/cart"], .checkout-btn, .cart-btn, [data-checkout]') ||
                              (event.target.textContent && event.target.textContent.toLowerCase().includes('checkout'));
      
      if (!isCheckoutButton) return;
      
      log('CHECKOUT button detected - ensuring wristband fee is added');
      
      const location = getBookingLocation();
      if (!location) {
        log('No location found for wristband fee on checkout');
        return;
      }
      
      if (!shouldAddWristband(location)) {
        log(`Wristband not required for ${location} on this date - allowing checkout`);
        return;
      }
      
      const feeInCart = await checkWristbandFeeInCart(location);
      if (!feeInCart && !isAddingFee) {
        log(`Rapid checkout detected! Adding wristband fee for ${location} immediately`);
        
        event.preventDefault();
        event.stopPropagation();
        
        await addWristbandFeeToCart(location);
        
        setTimeout(() => {
          if (event.target.href) {
            window.location.href = event.target.href;
          } else {
            event.target.click();
          }
        }, 200);
      }
    }, true);
  }
  
  function init() {
    log('Initializing wristband fee system');
    
    monitorAddToCartButtons();
    monitorCheckoutButtons();
    
    window.addEventListener('pageshow', () => {
      setTimeout(() => {
        monitorAddToCartButtons();
        monitorCheckoutButtons();
      }, 500);
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();